import * as React from "react";
import { TextBox } from "../../atoms/forms/TextBox";
import { ICommonInputsControlsWithLabel } from "../../atoms/forms/ICommonInputsControls";

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControlsWithLabel<string>;

export const ContactpointTextInput = (props: AllProps) => {
    return (
        <TextBox
            {...props}
        />
    );
}
